import { DASHBOARD_REFRESH_EVENT } from '../utils/dashboardEvents';
import { useCallback, useEffect, useRef, useState } from 'react';
import YoungApprenticeService from '../services/YoungApprenticeService';

/** Keep aggregate counts current while the dashboard is open. */
export default function useYoungApprenticeDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const refreshRef = useRef(() => {});
  const load = useCallback(() => refreshRef.current(), []);

  useEffect(() => {
    let disposed = false;
    let inFlight = false;
    let pendingChange = false;
    const refresh = async () => {
      if (disposed || inFlight || document.visibilityState === 'hidden') return;
      inFlight = true;
      try {
        const next = await YoungApprenticeService.dashboard();
        if (!disposed) { setData(next); setError(''); }
      } catch (err) {
        if (!disposed) setError(err?.response?.data?.error || 'Não foi possível atualizar o Dashboard.');
      } finally {
        inFlight = false;
        if (!disposed) setLoading(false);
        if (pendingChange && !disposed) { pendingChange = false; refresh(); }
      }
    };
    const changed = () => { if (inFlight) pendingChange = true; else refresh(); };
    const events = ['ibpm:student-list-refreshed', 'ibpm:attendee-list-refreshed', DASHBOARD_REFRESH_EVENT];
    refreshRef.current = changed;
    refresh();
    const timer = window.setInterval(refresh, 2000);
    window.addEventListener('focus', refresh);
    events.forEach(event => window.addEventListener(event, changed));
    document.addEventListener('visibilitychange', refresh);
    return () => {
      disposed = true;
      window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
      events.forEach(event => window.removeEventListener(event, changed));
      document.removeEventListener('visibilitychange', refresh);
      refreshRef.current = () => {};
    };
  }, []);

  return { data, loading, error, load };
}
